<template>
  <v-dialog v-model="isOpen" max-width="480" persistent>
    <v-card>
      <v-card-title primary-title dark>
        Excluir
      </v-card-title>

      <v-card-text class="pt-6">

        <h3>
          Deseja realmente <b>excluir</b> este item {{item.name}} ?
        </h3>

      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelDeletion">
          Cancelar
        </v-btn>
        <v-btn text @click="confirmDeletion">
          Excluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeletionConfirmationModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
    deletionConfirmed: false,
  }),
  methods: {
    cancelDeletion() {
      this.isOpen = false;
      this.$emit('close');
    },
    confirmDeletion() {
      this.isOpen = false;
      this.$emit('confirm', this.item);
    },
  },
  watch: {
    open(newValue) {
      this.isOpen = newValue;
    },
  },
  beforeMount() {
    this.isOpen = this.open;
  },
};
</script>
